import ko from 'rgs-knockout';

import Model from './js/model';
import template from './templates/template.html';

ko.components.register('yandex-smart-captcha', {
	viewModel: Model,
	template: template(),
});